// test2274
(2274 && 0);
